import styles from './home.module.css'
import {
    getLogo,
    getAppName,
    getLegalInfo,
    getHomeDescription,
    getHomeIllustration,
    isAppDownloadEnabled,
} from '../../hooks/useBrandConfig'
import box from '../../Assets/Bisoft_UI/Buttons/Active with shadow/Homepage/container@2x.png'
import android from '../../Assets/Bisoft_UI/Buttons/Active with shadow/Homepage/android@2x.png'
import ios from '../../Assets/Bisoft_UI/Buttons/Active with shadow/Homepage/ios@2x.png'
import plodeBtn from '../../Assets/Bisoft_UI/Buttons/Active with shadow/Homepage/plodeWeb@2x.png'
import { useHistory } from 'react-router'
import { browserName, browserVersion, isMobile } from 'react-device-detect'
import App from '../../App'
import { languageWords } from '../../utils/langaugeSupport'
import { connect } from 'react-redux'

function HomePage(params) {
    let history = useHistory()
    const languageName = params.device.language

    const Logo = getLogo('primary')

    var supportedBrowser = false
    if (
        browserName == 'Chrome' ||
        browserName == 'Edge' ||
        browserName == 'Opera'
    ) {
        if (parseInt(browserVersion) > 89) {
            console.log(parseInt(browserVersion), 'versionbrowser')
            supportedBrowser = true
        }
    }
    return (
        <>
            {/* grid 2 rows */}
            <div className={styles.mainContainer}>
                {/* ROW1===grid 2 cols */}
                <div className={styles.mainBody}>
                    {/* col1 */}
                    <div className={styles.mainImageContainer}>
                        <img
                            src={getHomeIllustration()}
                            className={styles.mainImage}
                        ></img>
                    </div>
                    {/* col 2 */}
                    <div className={styles.mainContentContainer}>
                        <div className={styles.logoContainer}>
                            <img
                                src={Logo}
                                className={styles.mainContentLogo}
                            ></img>
                        </div>
                        <div className={styles.paragraphContainer}>
                            <div className={styles.paragraph}>
                                {getHomeDescription() || (
                                    <>
                                        {getAppName()} is an all in one coding &
                                        tinkering environment which provides
                                        effortless and par excellence features
                                        to your kid with which they can create
                                        the machines of future. {getAppName()}{' '}
                                        is not only an App but it is an
                                        integrated development environment over
                                        which sits the fun remote control
                                        front-end, unique hexagonal coding
                                        blocks, flowchart based coding, block
                                        based coding & matchless python and C
                                        scripters. While peripheral modes such
                                        as Play, Make, and App mode, integrate
                                        complementarity into the ecosystem, with
                                        products such as Play Computer which
                                        provides a playful approach to
                                        innovations. {getAppName()} Application
                                        can connect with the Play Computer and
                                        our vast collection of add-ons,
                                        accessories and sensors that makes Play
                                        Computer even smarter.
                                    </>
                                )}
                            </div>
                        </div>
                        <div className={styles.buttonsContainer}>
                            {/* <button>Open web app</button>
              <div>
                {" "}
                *Plode web app is still in beta version, kindly use the android
                or ios app for a better experience.
              </div> */}
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: isAppDownloadEnabled()
                                        ? 'auto auto'
                                        : '1fr',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: isAppDownloadEnabled()
                                        ? '100%'
                                        : '25vw',
                                    margin: '0 auto',
                                    gap: '1vw',
                                }}
                            >
                                <div
                                    className={styles.box}
                                    style={{
                                        width: isAppDownloadEnabled()
                                            ? undefined
                                            : '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        background:
                                            'linear-gradient(to right, rgb(244,167,86), rgb(242,129,104))',
                                    }}
                                >
                                    {/* <img
                                        src={plodeBtn}
                                        className={styles.boxImage}
                                        onClick={() => {
                                            history.push('/login')
                                            window.location.reload(true)
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    ></img> */}
                                    <div
                                        onClick={() => {
                                            history.push('/login')
                                            window.location.reload(true)
                                        }}
                                        className={styles.boxImage}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            fontSize: '15px',
                                            color: 'white',
                                            fontFamily: 'Halcyon_SemiBold',
                                            width: isAppDownloadEnabled()
                                                ? undefined
                                                : '100%',
                                        }}
                                    >
                                        {'Open ' + getAppName()}
                                    </div>
                                </div>
                                {!isAppDownloadEnabled() ? null : (
                                    <div
                                        className={styles.box}
                                        style={{
                                            padding: '0px 15px',
                                        }}
                                    >
                                        <p className={styles.boxItem}>
                                            {languageWords[languageName]
                                                ?.TryNow || 'Try Now'}
                                        </p>
                                        {/* Added a flex wrapper for the icons with a gap */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '15px',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <img
                                                src={android}
                                                style={{
                                                    height: '22px',
                                                    cursor: 'pointer',
                                                    objectFit: 'cover',
                                                    width: '18px',
                                                    scale: '1.7',
                                                }}
                                                onClick={() => {
                                                    window.location.href =
                                                        'https://play.google.com/store/apps/details?id=com.bibox.bisoftsuite'
                                                }}
                                            />
                                            <img
                                                src={ios}
                                                style={{
                                                    height: '22px',
                                                    cursor: 'pointer',
                                                    objectFit: 'cover',
                                                    width: '18px',
                                                    scale: '1.7',
                                                }}
                                                onClick={() => {
                                                    window.location.href =
                                                        'https://apps.apple.com/in/app/plode/id1580203387'
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div
                                style={{
                                    fontSize: '0.7vw',
                                    marginLeft: '20px',
                                    color: 'grey',
                                    width: '27vw',
                                }}
                            >
                                {isMobile ? (
                                    isAppDownloadEnabled() ? (
                                        <div className={styles.msg}>
                                            If you would like to connect the
                                            hardware kindly use this website on
                                            a Desktop/Laptop or download the{' '}
                                            {getAppName()} App from the
                                            PlayStore/AppStore
                                        </div>
                                    ) : (
                                        <div className={styles.msg}>
                                            If you would like to connect the
                                            hardware kindly use this website on
                                            a Desktop/Laptop
                                        </div>
                                    )
                                ) : supportedBrowser == false ? (
                                    <div className={styles.msg}>
                                        Kindly use the latest version of Google
                                        Chrome or Microsoft Edge to view this
                                        website
                                    </div>
                                ) : null}
                                {/* // {supportedBrowser == false ? (<div className={styles.msg}>Kindly use the latest version of Google Chrome
                //  or Microsoft Edge to view this website</div>) : null } */}
                                {isAppDownloadEnabled() && (
                                    <>
                                        *{getAppName()} Web App is still in
                                        beta, kindly use the android or ios app
                                        for a better experience.
                                    </>
                                )}
                            </div>
                        </div>

                        <div className={styles.bottomTextDiv}>
                            <p className={styles.copyRightText}>
                                <span style={{ fontSize: '1.1rem' }}>
                                    &copy;
                                </span>
                                {'  '}
                                {getLegalInfo().copyright_text}
                                {/* PLAYFULLY CRAFTED BY YUDU ROBOTICS */}
                            </p>
                        </div>
                    </div>
                </div>
                {/* ROW2 */}
                <div className={styles.footer}>
                    <div
                        className={styles.privacyPolicy}
                        onClick={() => {
                            getLegalInfo().terms_url
                                ? window.open(
                                      getLegalInfo().terms_url,
                                      '_blank'
                                  )
                                : history.push('/TermsAndConditions')
                        }}
                    >
                        Terms & Conditions
                    </div>
                    <div
                        className={styles.privacyPolicy}
                        onClick={() => {
                            getLegalInfo().privacy_url
                                ? window.open(
                                      getLegalInfo().privacy_url,
                                      '_blank'
                                  )
                                : history.push('/privacyPolicy')
                        }}
                    >
                        Privacy Policy
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}

export default connect(mapStateToProps)(HomePage)
